var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGabsMood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D3A798;}\r\n\t.st1{fill:#D27B72;}\r\n\t.st2{fill:#AA867D;}\r\n\t.st3{fill:#E5BDB3;}\r\n\t.st4{fill:#4E0904;}\r\n\t.st5{fill:#DD6688;}\r\n\t.st6{fill:#F5F4F3;}\r\n\t.st7{fill:#030303;}\r\n\t.st8{fill:#BA2597;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "face",
    className: "st0",
    d: "M903.2,519.2c0,224.5-181.1,406.4-404.4,406.4S87.4,747.8,87.4,523.4s188-410.6,411.4-410.6 c124.8,0,225.8,67.4,300,156.6C857.4,340,903.2,420.1,903.2,519.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cheeks"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 733.1,
    cy: 592,
    rx: 85.9,
    ry: 87
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 268.6,
    cy: 595,
    rx: 85.9,
    ry: 83.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "nose_00000092453835108607783050000004870036331448112825_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nose-bridge",
    className: "st0",
    d: "M524.2,542.4c-15.6-5.8-31.3-9.1-47.5-2.6c-7.6,3.1-13-5.7-20.3-3.2 c2.2-8.4,4.4-16.9,6.4-25.4c1.2-4.9,4.4-6.8,9-6.8c3.8,0,7.5,0.1,11.3,0.1C518.3,504.6,520.1,506.2,524.2,542.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nose-shadow",
    className: "st2",
    d: "M412.6,592.4c17.8-13.6,26.3-32.9,39.1-49.6c8.3-2.5,14.4,6.3,22.9,3.2 c18.2-6.5,36-3.2,53.5,2.6c12.6,17.2,27.2,33,42.4,48.5c-5.3,9.4-16,9.1-24.5,8c-7.7-1-12.5,1.2-17.9,4.4 c-20.7,12.4-41.3,12.5-61.7-0.2c-5.5-3.4-10.8-4.4-18-4.1C435.1,605.6,423.1,600.1,412.6,592.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nose",
    className: "st3",
    d: "M421.8,586.2c15.8-13.6,23.3-32.9,34.7-49.6c7.3-2.5,12.7,6.3,20.3,3.2c16.2-6.5,31.9-3.2,47.5,2.6 c11.2,17.2,24.1,33,37.6,48.5c-4.7,9.4-14.2,9.1-21.7,8c-6.8-1-11.1,1.2-15.8,4.4c-18.3,12.4-36.6,12.5-54.8-0.2 c-4.9-3.4-9.6-4.4-15.9-4.1C441.7,599.4,431.1,593.9,421.8,586.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "brow",
    className: "st4",
    d: "M297.8,321.8c20.2-19,42.8-17.5,65.4-10.7c18,5.4,34.8,14.1,50.5,24.6c10.9,7.3,11.2,9,2.5,21 C382.7,325.5,347.6,298.9,297.8,321.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lips"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M439.8,693.8c11.2-17.5,25.3-37.7,39.1-37.2c6.8,0.3,10.6,8.6,18.8,8.1c9.1-0.5,10.4-7.2,17.6-8 c17.6-2,39.4,36.3,39.4,36.4l-1.3,1.7c6.3-7.6-9.5,13.8-18.2,19.3c-21,13.4-55.2,7.3-58.5,6c-8.8-3.5-29.3-15.7-36.8-23.2 C438.9,696,439.2,694.7,439.8,693.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M453.3,690.4c-1.6,0.3,8.7-6.3,20.9-7c0.3,0,0.5,0,0.5,0c10.9-0.4,13.3,4.1,20.5,4.1c6.6,0,17.6-4,19.6-4.1 c0.3,0,0.6,0,0.6,0s1.2,0,2.4,0c7.7,0.3,16.6,4.7,16.6,4.7c3.4,1.7,11.5,6.3,10.1,6c-3.4-0.6-9.1-6.2-24.3-6.6 c-10.4-0.3-15.9,3.7-25.8,2.9c-9.7-0.7-10.3-2.4-18.4-2.7C462.4,687.2,460.1,689.1,453.3,690.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glasses_00000171700030550360197380000015550833797799520387_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "glasses",
    className: "st6",
    d: "M782.3,484.6c0,74.1-60,134.1-134.1,134.1c-65.4,0-119.8-46.8-131.7-108.7 c-0.8,0.1-1.5,0-2.3-0.2c-3.1-0.8-5.4-3.3-8.2-4.8c-6.7-3.9-15.2-2.4-22.8-0.8c-5.3,1.1-10.6,2.2-16,3.4 c-10.8,63.2-65.9,111.3-132.2,111.3c-74.1,0-134.1-60-134.1-134.1c0-74.1,60-134.1,134.1-134.1c67.3,0,123,49.6,132.6,114.2 c4.6,0,12.9,3.1,16,3.4c7.2,0.9,14.5,0.9,21.7-0.1c3.5-0.5,7.1-1.1,10.1-3c9.4-64.9,65.2-114.8,132.7-114.8 C722.2,350.5,782.3,410.6,782.3,484.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 344.8,
    cy: 496.7,
    r: 108.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 640,
    cy: 496.7,
    r: 108.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "hair"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1079.8,742.4c-6.3,41.6-20.3,79.7-49.7,110.8c-23,24.3-51.4,37.2-84.6,42c-41.2,6-80.2-2.4-118.9-14.9 c-7.4-2.4-14.9-2.7-22.1-0.2c-32,11.2-59.8,3.9-84.3-18.5c0.3-5.5,4.7-7.4,8.5-10.1c69.7-48.8,119.8-112.9,149.3-192.7 c21-56.6,28.9-115.1,23.7-175.4c-0.5-5.7-1.5-9.5-8-10.6c-42.1-7.2-60.2-39.2-74.9-74c-7.5-17.7-13.3-36.2-20-54.3 c-8.9-24-23-28.3-43.3-13.3c-27.1,20-58.3,19.3-84.6-1.9c-5.2-4.2-10.4-8.5-15-13.3c-10.4-10.9-19.1-22.6-21.4-38.6 c-2.3-16.4-9.4-31-20.7-43.7c-16-17.9-36.2-25.2-59.4-25.2c-36.8,0-71.6-6.8-103-27.1c-5.8-3.7-8.3-7.9-9.3-15 c-2.2-16.3-0.9-32.7-2.2-49c6.1-4.2,13.4-3.8,20.1-4.2c36.1-2,72.3,0,107.9,6.2c37.2,6.4,72.8,18.6,106.9,35.2 c54.3,26.3,99.3,63.9,137.4,110.6c27.3,33.4,48.2,70.1,64.4,110.1c9.3,23,25,43,35.4,65.8c11.9,26.1,21.6,52.9,30.4,80.1 c14,43.1,26.8,86.5,40.6,129.7c4.2,13.1,12.3,24.1,20.1,35.4c17.1,24.7,42.5,36.8,69.8,45.7 C1078.6,734.2,1080.8,735.6,1079.8,742.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M430.2,147.5c4.5,41.4-18.1,69.3-46.9,93.4c-45.9,38.4-101.6,51.6-159.3,58.7c-5,0.6-9.9,1.4-14.9,1.9 c-22.2,2.6-21.9,2.6-26.4,23.8c-11.1,52.6-28.8,102.4-62.5,145.3c-2.6,3.3-5,7.1-8.3,9.4c-17.2,12-20.2,28.7-19.4,48.4 c3.3,78.9,26.3,151.1,70.2,216.8c43.3,64.9,101.3,112,171.7,144.6c-30.5,27-66.4,31.1-105.1,25.8c-39.3-5.3-73.8-21.8-106.7-42.5 c-11.6-7.3-24.4-8.2-36.9-11c-16.9-3.8-32.9-9.8-48-18.1C6.2,826.4-5.5,796.6,2.4,761.9c4.5-19.8,14.8-36.9,25.6-53.7 c3.5-5.5,7.5-6.4,13.6-3.5c19.8,9.3,31.8,3.6,37.5-17.1c5.4-19.5,2.9-39,0.1-58.5c-6.5-47.1-6.9-93.9-0.5-141.2 c7.1-52.4,24.9-100.9,50.6-146.5c14-24.7,33-46.6,47.4-71.2c16.8-28.6,38.1-53.4,63.5-73.5c27.8-22,58.6-40.6,92.3-53.4 c26.1-9.9,53.1-16.9,80-23.8c5.5-1.4,11.6-0.7,17.5-1C430,128.2,429.1,137.9,430.2,147.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGabsMood);
export default __webpack_public_path__ + "static/media/gabs-mood.bdf8685209cf623955f91636cb7dbcfd.svg";
export { ForwardRef as ReactComponent };